import {configureStore} from "@reduxjs/toolkit";

import { reportSliceReducer } from "./report-slice";
import { formDataSliceReducer } from "./form-data-slice";

export const store = configureStore({
  reducer: {
    report: reportSliceReducer,
    formData: formDataSliceReducer,
  },
  devTools: true,
});

export default store;

export type RootState = ReturnType<typeof store.getState>;